import React from 'react';
import { translate } from 'react-i18next';

import styles from './FeatureName.module.scss';

export class FeatureName extends React.Component {
  constructor (props) {
    super(props);
    this.inputName = React.createRef();
  }

  componentDidMount () {
    const { feature: { properties: { label, name } }, id, t } = this.props;
    this.updateLabel(label || `${t(name)} ${id + 1}`);
  }

  componentDidUpdate ({ feature: { properties: { label: prevLabel } } }) {
    const { feature: { properties: { label } } } = this.props;
    if (label !== prevLabel) {
      this.updateLabel(label);
    }
  }

  handleChange = ({ target: { value } }) => {
    const { feature: { properties: { label } } } = this.props;
    const newValue = value || label;

    this.updateLabel(newValue);
    this.inputName.current.value = newValue;
  }

  updateLabel = label => {
    const { feature } = this.props;
    this.props.updateFeatureName(feature, label);
  }

  render () {
    const { feature: { properties: { label: labelProp, name } }, id, t, editable } = this.props;

    // Fallback label to `${t(name)} ${id}` for retrocompatibility purpose
    const label = labelProp || `${t(name)} ${id + 1}`;

    if (!editable) {
      return <span>{label}</span>;
    }

    return (
      <input
        ref={this.inputName}
        className={styles.feature}
        defaultValue={label}
        onBlur={this.handleChange}
        maxLength={30}
      />
    );
  }
}

export default translate('Features')(FeatureName);



// WEBPACK FOOTER //
// ./src/components/FormMap/FeatureName.js